import HoroscopeService from '@/common/api/horoscope'
import {
  GET_HOROSCOPE
} from './actions'
import {
} from './mutations'

const state = {
}

const getters = {
}

const actions = {
  [GET_HOROSCOPE] (context, params = {}) {
    return new Promise((resolve, reject) => {
      HoroscopeService.getHoroscope(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}
